/* eslint-disable react/forbid-prop-types */
/* eslint-disable newline-per-chained-call */
import { timeSpanRegex } from "@iventis/utilities";
import * as Yup from "yup";
import { Content } from "@iventis/translations/content/typed-content";
import { UseIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { isFirstTimeStringBefore, isTimeStringValid } from "./schedule-helper-functions";

export const defaultCreateSessionValidations = (translate: UseIventisTranslate) => ({
    sessionCode: Yup.object({
        sessionCodePrefix: Yup.string()
            .required("Required")
            .max(10, "Max 10 characters")
            .matches(/^[A-Za-z0-9]+$/, "Letters or numbers required"),
        sessionCodeDigit: Yup.string()
            .required("Required")
            .max(10, "Max 10 characters")
            .matches(/^[0-9]+$/, "Digits required"),
    }),
    // Duration has to be an integer
    duration: Yup.number().integer(),
    // Start time has to be a string
    startTime: Yup.string()
        .nullable(false)
        .required("HH:mm:ss")
        .test("isValid", translate(Content.schedule2.validation.startTimeValid), (startTime) => isTimeStringValid(startTime)),
    // End time has to be a string
    endTime: Yup.string()
        .required("HH:mm:ss")
        .nullable(false)
        .when("startTime", (startTime, schema: Yup.StringSchema) =>
            schema.test("isBefore", translate(Content.schedule2.validation.endTimeBeforeStartTime), (endTime) => isFirstTimeStringBefore(startTime, endTime))
        )
        .test("isValid", translate(Content.schedule2.validation.endTimeValid), (endTime) => isTimeStringValid(endTime)),
    sessionDescription: Yup.string().nullable().max(1000, "Max 1000 characters"),
    sessionDay: Yup.number()
        .integer()
        .transform((value) => (Number.isNaN(value) ? undefined : value))
        .required("Required")
        .nullable(),
    estimatedEndTime: Yup.boolean(),
    spareDay: Yup.boolean(),
    selectedEvents: Yup.array(
        Yup.object().shape({
            item: Yup.object(),
            children: Yup.array(Yup.object()),
        })
    ),
    zeroTimeDisabled: Yup.boolean(),
    zeroTime: Yup.string().when(["zeroTimeDisabled"], {
        is: true,
        then: Yup.string().nullable(true),
        otherwise: Yup.string().matches(timeSpanRegex, "(+/-) hh:mm:ss").required(),
    }),
    venueLocation: Yup.object().required(),
});
